import { graphql } from '../gql';

export const recordConsentPreferenceEvent = graphql(`
  mutation RecordConsentPreferenceEvent($input: ConsentPreferenceEventInput!) {
    recordConsentPreferenceEvent(input: $input) {
      eventId
      error {
        code
        message
      }
    }
  }
`);
